import { adminHealthAdapter, HealthStatusPage } from '@pa/staff'
import { useMemo } from 'react'

/**
 * S-04 Health tab (UserFlows S-04: "the same content as C-12, for this clinic"): the shared `health` feature over the
 * admin adapter (#52, #60 `?clinicId=`, Frontend §7.2). Times in the clinic's zone; `page` for the incidents.
 */
export function HealthTab({
  clinicId,
  timeZone,
  page,
  onPage,
}: {
  clinicId: string
  timeZone: string
  page: number
  onPage: (page: number) => void
}) {
  const adapter = useMemo(() => adminHealthAdapter(clinicId), [clinicId])
  return <HealthStatusPage adapter={adapter} timeZone={timeZone} page={page} onPage={onPage} layout="tab" />
}
